/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import AutoActionMailContentEditView from '../../view/pages/auto_action/AutoActionMailContentEditView'
import SmtpSettingOptionsStore from '../../store/options/SmtpSettingOptionsStore'
import AutoMailActions from '../../action/auto_action/AutoMailActions'
import AutoMailContentActions from '../../action/auto_action/AutoMailContentActions'
import AutoActionMailContentStore from '../../store/auto_action/AutoActionMailContentStore'

class AutoActionMailContentContainer extends Component {
  static getStores() {
    return [AutoActionMailContentStore, SmtpSettingOptionsStore]
  }

  static calculateState(prevState, props) {
    return {
      content: AutoActionMailContentStore.getState(),
      smtp_setting_options: SmtpSettingOptionsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    AutoMailActions.fetchSmtpSettings()
    if (this.state.match.params.id) {
      // 自動アクションのログからメール情報を取得する
      AutoMailContentActions.getAutoActionMailContent(this.state.match.params.id)
    }
  }

  render() {
    return AutoActionMailContentEditView(this.state)
  }
}

export default withRouter(Container.create(AutoActionMailContentContainer, { withProps: true }))
